import Backbone from "backbone";
import PromisedSyncHoc from "scripts/hoc/promisedSyncHoc";
import ValidatableModelHoc from "scripts/hoc/validatableModelHoc";

class BaseModel extends PromisedSyncHoc(ValidatableModelHoc(Backbone.Model)) {}

export default BaseModel;
